import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

import {
  ExtendedBox,
  Drawer,
  CoverVideo,
  ExtendedFlex,
} from '../coreui';

import ScrollToHash from '../components/ScrollToHash';
import Section from '../ioDetails/components/section';
import SubNav from '../components/subNav';
import ReitHeader from './components/reitHeader';
import Performance from './performance';
import InvestToday from '../ioDetails/components/investToday';
import ThingsYouShouldKnow from './thingsYouShouldKnow';
import Graphic3ColCallout from '../components/Graphic3ColCallout';
import Strategy from './strategy';
import PortfolioStats from './portfolioStats';
import Portfolio from './portfolio';
import DocumentItem from '../ioDetails/components/documentItem';
import Video1 from '../assets/mogulreiti.m4v';
import Video2 from '../assets/mogulreitii.m4v';
import Back from '../ioDetails/components/back';
import PrimaryLinks from '../ioDetails/components/primaryLinks';

import QuickLinks from '../ioDetails/components/quicklinks';

import OverViewDetails from '../ioDetails/components/overviewDetails';
import bg from '../assets/white95pct.png';

import { strategy, overview, quicklinks } from './strings';

class Reit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { title: 'Overview', name: 'overview' },
        { title: 'Strategy', name: 'strategy' },
        { title: 'Performance', name: 'performance' },
        { title: 'Portfolio', name: 'portfolio' },
        { title: 'FAQS', name: 'frequentlyaskedquestions' },
        { title: 'Resources', name: 'resources', responsiveHide: true },
      ],
    };
    this.setRef = this.setRef.bind(this);
    this.toggleOffering = this.toggleOffering.bind(this);
    this.toggleWebinar = this.toggleWebinar.bind(this);
    this.docsDrawer = null;
    this.webinarDrawer = null;
  }

  setRef(el, name) {
    if (!this[name] && el) {
      this[name] = el;
    }
  }

  toggleOffering() {
    this.docsDrawer.toggleDrawer();
  }

  toggleWebinar() {
    this.webinarDrawer.toggleDrawer();
    this.webinarDocumentItem.toggleModal();
  }

  render() {
    const io = this.props.io;
    const highlights = this.props.highlights;
    const faqItems = this.props.faqItems;
    const details = this.props.details;
    const user = this.props.user;

    const webinar = {
      webinar: null,
      comingSoon: null,
    };

    let strat = {};
    let ov = {};
    let Video = null;
    let ql = [];

    switch (io.id) {
      case 274949:
        strat = strategy.mr2;
        ov = overview.mr2;
        Video = Video2;
        ql = quicklinks.mr2;
        break;
      default:
        strat = strategy.mr1;
        ov = overview.mr1;
        ov.title = 'Since inception, the REIT has distributed between 6% and 8% annualized based on purchase price.';
        Video = Video1;
        ql = quicklinks.mr1;
        break;
    }

    return (
      <ExtendedBox>
        <ExtendedFlex
          flexDirection="column"
        >
          {
            user && user.isStaff &&
            <PrimaryLinks
              items={[
                { path: `/node/${io.id}/edit`, text: 'Edit' },
                { path: `/node/${io.id}/salesforce_activity`, text: 'Salesforce Activity' },
                { path: `/node/${io.id}/documents`, text: 'Documents' },
                { path: `/node/${io.id}/orders`, text: 'orders' },
              ]}
            />
          }
          <Back />
        </ExtendedFlex>
        <ReitHeader
          title={io.label}
          subTitle={io.blurb}
          highlights={highlights}
          id={io.id}
        />
        <ExtendedBox
          maxHeight={[null, null, 600]}
          minHeight={['inherit', 'inherit', '700px']}
          width="100%"
          m="auto"
          mt={[20, 20, 20, 40, 80]}
          overflowY="hidden"
          position="relative"
        >
          <CoverVideo
            autoPlay
            muted
            loop
            id="mogulreiti"
            width="100%"
            height="100%"
            minHeight={[0, 0, '700px']}
          >
            <source src={Video} type="video/mp4" />
          </CoverVideo>
          <ExtendedBox
            position={['relative', 'relative', 'absolute']}
            w={[1, 1, '100%']}
            maxWidth={['100%', '100%', 'auto']}
            height={['auto', 'auto', '100%']}
            top={['auto', 'auto', 0]}
            left={['auto', 'auto', 0]}
          >
            <ExtendedFlex
              position="relative"
              justifyContent={['center', 'center', 'flex-end']}
              alignItems="center"
              height="100%"
              maxWidth={1440}
              mx="auto"
            >
              <OverViewDetails
                width={['100%', '100%', '460px']}
                my={0}
                height="auto"
                mr={['auto', 'auto', 100, 100, 100]}
                details={details}
                id={io.id}
                smartButton={io.smartButton}
                watchList={io.watchList}
                style={{
                  backgroundImage: `url(${bg})`,
                  backgroundRepeat: 'repeat',
                }}
                p={[0, 0, 20]}
              />
            </ExtendedFlex>
          </ExtendedBox>
        </ExtendedBox>
        <ExtendedBox
          maxWidth={1440}
          m="auto"
        >
          <QuickLinks
            webinar={webinar}
            documents={ql}
          />
        </ExtendedBox>
        <SubNav
          items={this.state.navItems}
          smartButton={io.smartButton}
        />
        <Section
          bg="white"
          title="Overview"
          name="overview"
        >
          <Graphic3ColCallout
            description={ov.sub}
            subtitle={ReactHtmlParser(ov.title)}
            items={io.highlights}
            disclaimer={ov.dis}
          />
        </Section>
        <Strategy
          name="strategy"
          labelTop={strat.strategy.label}
          valueTop={strat.strategy.blurb}
          labelBottom={strat.result.label}
          valueBottom={strat.result.blurb}
          labelRight={strat.process.label}
          valueRight={strat.process.blurb}
        />
        <Section
          bg="white"
          title="Historical Performance"
          name="performance"
        >
          <ScrollToHash
            name="historical"
            offset={-75}
          />
          <Performance
            io={io}
          />
        </Section>
        <Section
          bg="gray.0"
          title="Portfolio Statistics"
          name="portfolio"
        >
          <PortfolioStats
            assets={io.assets.currentAssets}
            id={io.id}
          />
        </Section>
        <Section
          bg="white"
          title="Portfolio"
        >
          <ScrollToHash
            name="portfolio"
            offset={-75}
          />
          <Portfolio
            assets={io.assets}
            id={io.id}
          />
        </Section>
        <Section
          bg="gray.0"
          title="Frequently Asked Questions"
          name="frequentlyaskedquestions"
          subtitle="Common Questions and Important Considerations"
        >
          <ThingsYouShouldKnow
            faqItems={faqItems}
          />
        </Section>
        <Section
          bg="gray.0"
          title="Resources"
          name="resources"
        >
          <ScrollToHash
            name="offering"
            offset={-75}
            onComplete={this.toggleOffering}
          />
          <Drawer
            title="Offering Documents"
            ref={(el) => { this.setRef(el, 'docsDrawer'); }}
          >
            <ExtendedBox
              mt={10}
              mb={40}
              mx={40}
            >
              { io.offeringCircular &&
                io.offeringCircular.map((doc) => {
                  return (
                    <DocumentItem
                      doc={doc}
                      key={`fid_${doc.fid}`}
                      linkTarget="_blank"
                    />
                  );
                })}
              { io.investmentDocuments &&
                io.investmentDocuments.map((doc) => {
                  return (
                    <DocumentItem
                      doc={doc}
                      key={`fid_${doc.fid}`}
                      linkTarget="_blank"
                    />
                  );
                })}
            </ExtendedBox>
          </Drawer>
          <Drawer
            title="Forms"
          >
            <ExtendedBox
              mt={10}
              mb={40}
              mx={40}
            >
              { io.investmentDocumentsOther &&
                io.investmentDocumentsForms.map((doc) => {
                  return (
                    <DocumentItem
                      doc={doc}
                      key={`fid_${doc.fid}`}
                      linkTarget="_blank"
                    />
                  );
                })}
            </ExtendedBox>
          </Drawer>
          <ScrollToHash
            name="webinar"
            offset={-75}
            onComplete={this.toggleWebinar}
          />
          <Drawer
            title="Other"
          >
            <ExtendedBox
              mt={10}
              mb={40}
              mx={40}
            >
              { io.investmentDocumentsOther &&
                io.investmentDocumentsOther.map((doc) => {
                  return (
                    <DocumentItem
                      doc={doc}
                      key={`fid_${doc.fid}`}
                      linkTarget="_blank"
                    />
                  );
                })}
            </ExtendedBox>
          </Drawer>
        </Section>
        <Section
          bg="white"
        >
          <InvestToday smartButton={io.smartButton} />
        </Section>
      </ExtendedBox>
    );
  }
}

const mapStateToProps = (state) => ({
  io: state.reit.io,
  faqItems: state.reit.faqItems,
  highlights: state.reit.highlights,
  details: state.reit.details,
  user: state.app.user,
});

Reit.propTypes = {
  io: PropTypes.object,
  faqItems: PropTypes.array,
  highlights: PropTypes.object,
  details: PropTypes.array,
  user: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(Reit));
